/*
  Product page gallery redesign (2026-07-19)

  Two things this file does, both only at desktop widths (750px+) so the
  mobile experience is left completely untouched:

  1. Makes the left-hand thumbnail rail (see product-gallery-left-thumbnails.css)
     scroll vertically when its up/down buttons are clicked, instead of the
     horizontal scroll the stock slider-component provides.

  2. Makes the main photo's left/right buttons actually change the photo.
     Dawn's "thumbnail" gallery layout only ever shows the active media item
     (every other one is display:none) and expects you to switch photos by
     clicking a thumbnail; the prev/next buttons on the main image normally
     just scroll a row that's mostly hidden, so nothing visibly happens. We
     replace that with directly advancing to the next/previous media item.
*/
(function () {
  function initMainImageArrowNav() {
    var desktopQuery = window.matchMedia('(min-width: 750px)');

    document.querySelectorAll('.product--thumbnail media-gallery').forEach(function (gallery) {
      var viewer = gallery.querySelector('[id^="GalleryViewer-"]');
      if (!viewer) return;
      var buttonsWrapper = viewer.querySelector('.slider-buttons');
      if (!buttonsWrapper) return;

      buttonsWrapper.addEventListener(
        'click',
        function (event) {
          if (!desktopQuery.matches) return;
          var button = event.target.closest('.slider-button--prev, .slider-button--next');
          if (!button) return;

          event.preventDefault();
          event.stopPropagation();

          if (typeof gallery.setActiveMedia !== 'function') return;

          var items = Array.from(viewer.querySelectorAll('.product__media-item'));
          if (!items.length) return;
          var activeIndex = items.findIndex(function (item) {
            return item.classList.contains('is-active');
          });
          if (activeIndex === -1) activeIndex = 0;

          var direction = button.classList.contains('slider-button--next') ? 1 : -1;
          var nextItem = items[(activeIndex + direction + items.length) % items.length];
          gallery.setActiveMedia(nextItem.dataset.mediaId, false);
        },
        true
      );
    });
  }

  function initVerticalThumbnailNav() {
    var desktopQuery = window.matchMedia('(min-width: 750px)');

    document.querySelectorAll('.product--thumbnail .thumbnail-slider').forEach(function (wrapper) {
      var list = wrapper.querySelector('.thumbnail-list');
      if (!list) return;

      // The stock slider-component disables its prev/next buttons based on
      // horizontal scroll math (scrollLeft / offsetLeft), which doesn't apply
      // once this rail is a vertical column. Overriding the instance's
      // `update` method stops most of that, but the component's constructor
      // also binds its scroll listener directly to the original method
      // (`this.slider.addEventListener('scroll', this.update.bind(this))`),
      // so that stale reference still fires — e.g. whenever the active
      // thumbnail auto-scrolls into view (media-gallery.js's
      // setActiveThumbnail). A MutationObserver is the reliable way to
      // stop it: instantly undo `disabled` no matter what set it.
      if (typeof wrapper.update === 'function') {
        wrapper.update = function () {};
      }
      wrapper.querySelectorAll('.slider-button').forEach(function (button) {
        button.removeAttribute('disabled');
        new MutationObserver(function () {
          if (button.hasAttribute('disabled')) button.removeAttribute('disabled');
        }).observe(button, { attributes: true, attributeFilter: ['disabled'] });
      });

      function scrollAmount() {
        var item = list.querySelector('.thumbnail-list__item');
        var itemHeight = item ? item.getBoundingClientRect().height : 100;
        return itemHeight * 2 + 20;
      }

      wrapper.addEventListener(
        'click',
        function (event) {
          if (!desktopQuery.matches) return;
          var button = event.target.closest('.slider-button--prev, .slider-button--next');
          if (!button || !wrapper.contains(button)) return;

          event.preventDefault();
          event.stopPropagation();

          var direction = button.classList.contains('slider-button--prev') ? -1 : 1;
          // Using 'auto' (instant) rather than 'smooth': smooth scrollBy can fail
          // to animate/settle in some automation and background-tab contexts, and
          // an instant jump is a perfectly normal, reliable pattern for this kind
          // of paging control regardless of browser/reduced-motion settings.
          list.scrollBy({ top: direction * scrollAmount(), behavior: 'auto' });
        },
        true
      );
    });
  }

  function init() {
    initMainImageArrowNav();
    initVerticalThumbnailNav();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
